import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export type { IAppDownloadBanner } from "./AppDownloadBanner";

export default lazyLoadComponentFactory(
    () => import(/* webpackChunkName: "Common_AppDownloadBanner" */ "./AppDownloadBanner"),
);
